import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import AutoFixHighRoundedIcon from "@mui/icons-material/AutoFixHighRounded";
import ConstructionRoundedIcon from "@mui/icons-material/ConstructionRounded";
import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbUpAltRounded";
import SettingsSuggestRoundedIcon from "@mui/icons-material/SettingsSuggestRounded";

const items = [
  {
    icon: (
      <SettingsSuggestRoundedIcon
        fontSize="large"
        sx={{ color: "primary.light" }}
      />
    ),
    title: "You design, We develop",
    description:
      "We transform your designs into fully functional solutions aligned with your business needs.",
  },
  {
    icon: (
      <ConstructionRoundedIcon
        fontSize="large"
        sx={{ color: "secondary.light" }}
      />
    ),
    title: "We design, We develop",
    description:
      "From concept to completion, we provide affordable and complete development services.",
  },
  {
    icon: (
      <ThumbUpAltRoundedIcon fontSize="large" sx={{ color: "success.light" }} />
    ),
    title: "Dedicated Team",
    description:
      "Our skilled team delivers top-quality development, testing, and quality assurance.",
  },
  {
    icon: (
      <AutoFixHighRoundedIcon fontSize="large" sx={{ color: "info.light" }} />
    ),
    title: "Project Basis",
    description:
      "Flexible and fast team formation for evolving project needs, ensuring expert execution.",
  },
];

export default function Highlights() {
  return (
    <Box
      id="highlights"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        bgcolor: "grey.900",
        color: "white",
      }}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: { xs: 3, sm: 6 },
        }}
      >
        <Box sx={{ width: { sm: "100%", md: "60%" }, textAlign: "center" }}>
          <Typography component="h2" variant="h4" gutterBottom>
            How We Can Work for You
          </Typography>
          <Typography variant="body1" sx={{ color: "grey.400" }}>
            Discover the adaptability, innovation, and reliability that set us
            apart. We tailor our approach to meet your evolving business needs.
          </Typography>
        </Box>
        <Grid container spacing={4}>
          {items.map((item, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card
                sx={{
                  p: 4,
                  backgroundColor: "grey.800",
                  borderRadius: "16px",
                  boxShadow: 5,
                  textAlign: "center",
                  minHeight: "300px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "transform 0.3s ease-in-out",
                  "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: 8,
                  },
                }}
              >
                <Stack alignItems="center" spacing={2}>
                  {item.icon}
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    sx={{ color: "grey.100" }}
                  >
                    {item.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "grey.400" }}>
                    {item.description}
                  </Typography>
                </Stack>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
